// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgageSavingMethod.proto

export enum ENUM_MortgageSavingMethod {
  MORTGAGE_SAVING_METHOD_UNSPECIFIED = 'MORTGAGE_SAVING_METHOD_UNSPECIFIED',
  MORTGAGE_SAVING_METHOD_TOTAL_SAVINGS = 'MORTGAGE_SAVING_METHOD_TOTAL_SAVINGS',
  MORTGAGE_SAVING_METHOD_CASH_SAVINGS = 'MORTGAGE_SAVING_METHOD_CASH_SAVINGS',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
